<p-dropdown #dropdown *ngIf="visible" [(ngModel)]="value" [inputId]="id" [name]="name" [tabindex]="tabindex"
  [options]="options" [optionLabel]="optionLabel" [optionValue]="optionValue" [optionDisabled]="optionDisabled"
  [scrollHeight]="scrollHeight" [style]="style" [panelStyle]="panelStyle" [styleClass]="styleClass" [filter]="filter"
  [filterValue]="filterValue" [filterBy]="filterBy" [filterMatchMode]="filterMatchMode" [disabled]="disabled"
  [readonly]="readonly" [emptyMessage]="emptyMessage | i18next" [emptyFilterMessage]="emptyFilterMessage | i18next"
  [appendTo]="appendTo" [placeholder]="placeholder | i18next" [dataKey]="dataKey" [dropdownIcon]="dropdownIcon"
  [showClear]="showClear" (onClick)="mxClick($event)" (onChange)="mxChange($event)" (onFilter)="mxFilter($event)"
  (onFocus)="mxFocus($event)" (onBlur)="mxBlur($event)" (onShow)="mxShow($event)" (onHide)="mxHide($event)"
  (onClear)="mxClear($event)">
  <ng-template *ngIf="useSelectedItemTemplate" pTemplate="selectedItem" let-value>
    <div class="flex">
      <ng-container [ngTemplateOutlet]="selectedItemTemplateRef" [ngTemplateOutletContext]="{ $implicit: value }">
      </ng-container>
    </div>
  </ng-template>
  <ng-template *ngIf="useItemTemplate" pTemplate="item" let-value>
    <div class="flex">
      <ng-container [ngTemplateOutlet]="itemTemplateRef" [ngTemplateOutletContext]="{ $implicit: value }">
      </ng-container>
    </div>
  </ng-template>
</p-dropdown>